import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

class Schema extends PureComponent {
  render() {
    const { data } = this.props;
    const script = <script type="application/ld+json">{JSON.stringify(data)}</script>;
    return <Helmet>
      {script}
    </Helmet>;
  }
}

Schema.defaultProps = {
  data: {},
};

Schema.propTypes = {
  /** Data to add as a Helmet script */
  data: PropTypes.object,
};

export default Schema;
